export const LIGHTING_GUIDE_ROUTE =
  'blog-led-accessoires-vehicules-verifier-eclairage-voiture'

export const LIGHTING_GUIDE_EXCLUDED_LOCALES = ['ja']

export const LIGHTING_GUIDE_ARTICLES = {
  aim: 49,
  restore: 37,
  lowBeam: 55,
  plate: 43,
}

export const LIGHTING_GUIDE_RESTORE_CATEGORY_ID = 254

const LEGAL_ZONES = { fr: 'fr', de: 'de', en: 'gb' }

export function lightingGuideLegalZone(locale) {
  return LEGAL_ZONES[locale] || 'generic'
}

export function lightingGuideAvailable(locale) {
  return !LIGHTING_GUIDE_EXCLUDED_LOCALES.includes(locale)
}

export function categoryPageRoute(category) {
  const parent = category?.nested_parents_light
  const grandParent = parent?.nested_parents_light
  if (!category?.slug || !parent?.slug) return null
  if (grandParent?.slug) {
    return {
      name: 'categories-domain-category-subcategory',
      params: {
        domain: grandParent.slug,
        category: parent.slug,
        subcategory: category.slug,
      },
    }
  }
  return {
    name: 'categories-domain-category',
    params: { domain: parent.slug, category: category.slug },
  }
}

export function categoryRestrictedFor(category, locale) {
  return (
    Array.isArray(category?.restricted_locales) &&
    category.restricted_locales.includes(locale)
  )
}
